/** Formats stored lesson-go feedback for display. Numeric 1–10 values show as "N/10". */
export function formatHowDidLessonGoDisplay(value: string): string {
    const trimmed = value.trim();
    const n = Number(trimmed);
    if (trimmed !== '' && Number.isInteger(n) && n >= 1 && n <= 10) {
        return `${n}/10`;
    }
    return value;
}
